// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-footer{border-top:1px solid #eaeaea}.grid-form{display:grid;grid-template-columns:repeat(2,1fr);grid-gap:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
